import gql from 'graphql-tag';

export const GET_AI_CONFIG = gql`
  query {
    getAIConfiguration {
      configurations {
        name
        value
      }
      authorizedBy
    }
  }
`;

const GET_AI_FEATURE_GROUPS = gql`
  query {
    getAIFeatureGroups {
      featureGroupId
      name
      description
      enabled
      constant
    }
  }
`;

const GET_AI_INDIVIDUAL_FEATURES = gql`
  query($input: AIFeatureIdentifierInput!) {
    getAIFeature(input: $input) {
      featureId
      clientConfigurable
      clientConfigType
      clients {
        accountId
        name
      }
    }
  }
`;

const GET_AI_AGENT_ENTITY_SHARE = gql`
  query($input: AIFeatureIdentifierInput!) {
    getAIFeature(input: $input) {
      featureId
      entityShare {
        id
        roleShareType
        clientShareType
        clients {
          accountId
          name
        }
        roles {
          roleId
          name
        }
      }
    }
  }
`;

// Gives all data for the current AI Agent
const GET_AI_AGENT_DATA = gql`
  query($input: AIFeatureIdentifierInput!) {
    getAIFeature(input: $input) {
      featureId
      name
      constant
      enabledForLoggedInUser
      state
      agentData
      entityShare {
        id
        roleShareType
        clientShareType
        clients {
          accountId
          name
        }
        roles {
          roleId
          name
        }
      }
    }
  }
`;

const GET_AI_FEATURES_LIST_INDIVIDUAL = gql`
  query($input: GetAIFeatureListInput!) {
    getAIFeatureList(input: $input) {
      feature {
        featureId
        clientConfigurable
        clientConfigType
        state
        clients {
          accountId
          name
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

const GET_AI_CREDIT_LIMIT = gql`
  query {
    getAICreditLimit {
      userType
      aiGroup
      allowedCount
      consumedCount
    }
  }
`;

const GET_MY_ORG_AGENTS = gql`
  query($input: GetAIFeatureListInput!) {
    getAIFeatureList(input: $input) {
      feature {
        featureId
        name
        usageCount
        constant
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

const GET_AI_FEATURES_LIST = gql`
  query($input: GetAIFeatureListInput!) {
    getAIFeatureList(input: $input) {
      feature {
        featureId
        name
        description
        usageCount
        state
        userDefined
        displayIcon
        constant
        clientConfigurable
        prompt {
          prompt
        }
        subFeatures {
          featureId
          name
          description
          usageCount
          state
          userDefined
          displayIcon
          constant
        }
        aiFeatureGroup {
          featureGroupId
          name
          description
          enabled
          constant
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

const GET_AI_FEATURE_FEEDBACK_LIST = gql`
  query($input: GetAIFeatureFeedbackListInput!) {
    getAIFeatureFeedbackList(input: $input) {
      feedback {
        feedbackId
        user {
          userId
          name
          firstName
          lastName
        }
        ratingType
        rating
        prompt {
          feedbackId
          actualMessage
          aiMessage
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

// enabledForLoggedInUser
// TODO. NEed to query
const GET_AI_FEATURES = gql`
  query($input: GetAIFeatureListInput!) {
    getAIFeatureList(input: $input) {
      feature {
        featureId
        name
        state
        enabledForLoggedInUser
        constant
        agentData
        displayIconUrl
        subFeatures {
          featureId
          name
          description
          usageCount
          state
          userDefined
          displayIcon
          constant
          prompt {
            prompt
          }
        }
      }
      listInfo {
        page
        pageSize
      }
    }
  }
`;

const GET_WEB_SEARCH_ACCEPTANCE_INFO = gql`
  query {
    getWebSearchAcceptanceInfo
  }
`;

const GET_AI_FEATURE_ONBOARDING_ENTITY = gql`
  query getAIFeatureOnboardingEntity($input: AIFeatureIdentifierInput!) {
    getAIFeatureOnboardingEntity(input: $input)
  }
`;

const GET_TRIAGE_TICKET_LIST = gql`
  query($listInfo: ListInfoInput!, $isMSPProduct: Boolean!) {
    getTicketList(listInfo: $listInfo) {
      tickets {
        displayId
        ticketId
        subject
        status
        createdTime
        source
        priority
        ticketType
        requester {
          userId
          name
          email
          firstName
          lastName
          forgotten
        }
        client @include(if: $isMSPProduct) {
          name
          accountId
        }
        site {
          name
        }
        aiAgentActionData {
          aiFeature {
            featureId
            constant
          }
          status
          action {
            name
            actionValueType
            actionValueData
          }
        }
      }
      listInfo {
        totalCount
        sort {
          attribute
          order
        }
        page
        pageSize
        condition
      }
    }
  }
`;

const GET_TRIAGE_TICKET_DATA = gql`
  query getTicket($id: ID!) {
    getTicket(id: $id) {
      ticketId
      displayId
      aiAgentActionData {
        aiFeature {
          featureId
          constant
        }
        status
        action {
          name
          actionValueType
          actionValueData
        }
      }
    }
  }
`;

const GET_TICKET_TRIAGE = gql`
  query getTicket($id: ID!) {
    getTicket(id: $id) {
      ticketId
      displayId
      subject
      aiAgentActionData {
        aiFeature {
          featureId
          constant
        }
        status
        data
        action {
          name
          actionValueType
          actionValueData
        }
      }
    }
  }
`;

const GET_AI_FEATURE_METRIC_DATA = gql`
  query getAIFeatureMetricData($input: AIFeatureIdentifierInput!) {
    getAIFeatureMetricData(input: $input) {
      aiFeature {
        featureId
        constant
        name
      }
      data
    }
  }
`;
const GET_PATCH_AGENT_ACTIONS = gql`
  query {
    getPatchAgentActions {
      patchCount
      approvalStatus
      stabilitySeverity
      viewId
      condition
    }
  }
`;

const GET_AI_AGENT_NOTIFICATIONS = gql`
  query getAIAgentNotifications($input: GetAIAgentNotificationsInput!) {
    getAIAgentNotifications(input: $input) {
      aiFeature {
        featureId
        constant
      }
      count
    }
  }
`;

export {
  GET_AI_AGENT_DATA,
  GET_AI_AGENT_ENTITY_SHARE,
  GET_AI_CREDIT_LIMIT,
  GET_AI_FEATURE_FEEDBACK_LIST,
  GET_AI_FEATURE_GROUPS,
  GET_AI_FEATURE_METRIC_DATA,
  GET_AI_FEATURE_ONBOARDING_ENTITY,
  GET_AI_FEATURES,
  GET_AI_FEATURES_LIST,
  GET_AI_FEATURES_LIST_INDIVIDUAL,
  GET_AI_INDIVIDUAL_FEATURES,
  GET_MY_ORG_AGENTS,
  GET_TICKET_TRIAGE,
  GET_TRIAGE_TICKET_LIST,
  GET_WEB_SEARCH_ACCEPTANCE_INFO,
  GET_AI_AGENT_NOTIFICATIONS,
  GET_TRIAGE_TICKET_DATA,
  GET_PATCH_AGENT_ACTIONS
};
